<script setup lang="ts">
import type { Automation } from '@/types/Automation';
defineProps<{
  automation: Automation
}>();

function toolName(tool: string) {
	if(!tool) return;
  return tool.replace(' ', '-').toLowerCase();
}

function annualSaving(automation: Automation) {
		const annual = automation.cost_benefit_money_per_week * 52;

		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: automation.cost_benefit_currency ?? 'USD',
		}).format(annual).slice(0, -3);
}


</script>
<template>
	<NuxtLink
		v-if="automation.handle"
	:to="`/automation/${automation.handle}`" class="focus:outline-none" color="primary" orientation="vertical">
                <div class="gap-x-8 gap-y-4 rounded-xl flex flex-col flex-1 px-4 py-5 sm:p-6  ">
                  <div class="">
                    <p class="text-gray-900 dark:text-white text-base font-bold">
                      {{ automation.title }}
                    </p>
					 <div v-if="automation.automation_tools?.length" class="flex gap-2 py-2">

						<div v-for="tool in automation.automation_tools" :key="tool.id">
							<img :src="`/assets/images/apps/${toolName(tool.tool)}.png`" width="20px" height="20px" :alt="tool.tool" loading="lazy" class="rounded-xl">
						</div>
					</div>

					<div v-if="automation.cost_benefit_money_per_week > 0" class="py-2">
						<UBadge v-if="automation.cost_benefit_money_per_week "><strong>{{annualSaving(automation)}}</strong>&nbsp;Yearly Savings</UBadge>
					</div>

					<div v-else-if="automation.cost_benefit_hours_per_week" class="py-2">
						<UBadge v-if="automation.cost_benefit_hours_per_week"><strong>{{automation.cost_benefit_hours_per_week}}</strong>&nbsp;Hours Weekly Saved</UBadge>
					</div>

                  </div>
                </div>
    </NuxtLink>
</template>
